// Theme exports
import lavenderTheme from './lavender';
import oceanTheme from './ocean';
import pastelOceanTheme from './pastel_ocean';
import mintTheme from './mint';
import roseTheme from './rose';
import skyTheme from './sky';
import sunsetTheme from './sunset';
import forestTheme from './forest';
import desertTheme from './desert';
import mountainTheme from './mountain';
import riverTheme from './river';

// Enhance themes with dark mode variants
const createThemeVariants = (theme) => ({
  light: theme,
  dark: {
    ...theme,
    palette: {
      ...theme.palette,
      mode: 'dark',
      background: {
        default: theme.palette.primary.dark,
        paper: theme.palette.primary.main,
        subtle: theme.palette.primary.light,
      },
      text: {
        primary: '#FFFFFF',
        secondary: theme.palette.primary.light,
        disabled: theme.palette.primary.light,
      },
      divider: 'rgba(255, 255, 255, 0.12)',
    },
  },
});

export const themes = {
  lavender: createThemeVariants(lavenderTheme),
  ocean: createThemeVariants(oceanTheme),
  pastel_ocean: createThemeVariants(pastelOceanTheme),
  mint: createThemeVariants(mintTheme),
  rose: createThemeVariants(roseTheme),
  sky: createThemeVariants(skyTheme),
  sunset: createThemeVariants(sunsetTheme),
  forest: createThemeVariants(forestTheme),
  desert: createThemeVariants(desertTheme),
  mountain: createThemeVariants(mountainTheme),
  river: createThemeVariants(riverTheme),
};

export const themeNames = {
  lavender: 'Lavender Healing',
  ocean: 'Ocean Calm',
  pastel_ocean: 'Pastel Ocean Breeze',
  mint: 'Mint Wellness',
  rose: 'Rose Care',
  sky: 'Sky Serenity',
  sunset: 'Sunset Peace',
  forest: 'Forest Harmony',
  desert: 'Desert Solitude',
  mountain: 'Mountain Strength',
  river: 'River Flow',
};

export const defaultTheme = 'lavender';
// Add semantic color tokens for consistent usage
export const semanticColors = {
  success: {
    light: '#A8E6CF', // Modern mint
    main: '#69C683', // Fresh green
    dark: '#3D8A5F', // Deep green
    contrastText: '#ffffff'
  },
  warning: {
    light: '#FFD3B6', // Modern coral
    main: '#FF9A76', // Vibrant orange
    dark: '#E67553', // Deep orange
    contrastText: '#ffffff'
  },
  error: {
    light: '#FFB5B5', // Modern light red
    main: '#FF7285', // Vibrant red
    dark: '#E63946', // Deep red
    contrastText: '#FFFFFF'
  },
  info: {
    light: '#A7D7E8', // Modern sky
    main: '#5DADE2', // Vibrant blue
    dark: '#3498DB', // Deep blue
    contrastText: '#ffffff'
  },
};